// Row-shaped wrapper around InlineEditableField — FE-043b parity v2.
//
// The Pencil ``Commitment Detail`` frame uses a label-on-the-left,
// value-on-the-right row layout for every metadata field, instead
// of the boxed tile grid the FE-043 page used. This wrapper gives
// callers that layout while delegating the actual edit affordance
// to the existing ``InlineEditableField`` primitive.

import {
  InlineEditableField,
  type InlineEditableFieldProps,
} from "./InlineEditableField";


export interface InlineFieldRowProps
  extends Omit<InlineEditableFieldProps, "label"> {
  label: string;
}


export function InlineFieldRow({ label, ...rest }: InlineFieldRowProps) {
  return (
    <div
      data-testid={`detail-row-${rest.fieldId}`}
      className="grid grid-cols-[100px_1fr] items-start gap-3"
    >
      <span className="pt-1.5 text-xs text-text-tertiary">{label}</span>
      <div className="min-w-0">
        {/* Reuse the existing inline-edit primitive but suppress its
            stacked label — the row label lives in the grid above. */}
        <InlineEditableField {...rest} label="" />
      </div>
    </div>
  );
}
